import { memo } from "react";
import {
  Award,
  Banknote,
  BookOpen,
  Bell,
  Calendar,
  CalendarDays,
  Clock,
  Coins,
  Compass,
  CreditCard,
  Crown,
  Edit3,
  Film,
  Flag,
  Flame,
  FileText,
  Funnel,
  Gift,
  GraduationCap,
  Handshake,
  Heart,
  Hourglass,
  Image as ImageIcon,
  LayoutGrid,
  Layers,
  Library,
  Lightbulb,
  Mail,
  Map as MapIcon,
  Medal,
  Megaphone,
  MessageSquare,
  Mic,
  Music,
  Package,
  PenTool,
  Percent,
  Phone,
  Plus,
  Podcast,
  Radio,
  Rocket,
  School,
  Send,
  ShoppingBag,
  ShoppingCart,
  Sliders,
  Sparkles,
  Sprout,
  Star,
  Tag,
  Target,
  Ticket,
  Timer,
  TrendingUp,
  Trophy,
  UserPlus,
  Users,
  Video,
  Wallet,
  Wand,
  Zap,
  type LucideIcon,
} from "lucide-react";

const REGISTRY: Record<string, LucideIcon> = {
  award: Award,
  banknote: Banknote,
  "book-open": BookOpen,
  bell: Bell,
  calendar: Calendar,
  "calendar-days": CalendarDays,
  clock: Clock,
  coins: Coins,
  compass: Compass,
  "credit-card": CreditCard,
  crown: Crown,
  "edit-3": Edit3,
  film: Film,
  flag: Flag,
  flame: Flame,
  "file-text": FileText,
  funnel: Funnel,
  gift: Gift,
  "graduation-cap": GraduationCap,
  handshake: Handshake,
  heart: Heart,
  hourglass: Hourglass,
  image: ImageIcon,
  "layout-grid": LayoutGrid,
  layers: Layers,
  library: Library,
  lightbulb: Lightbulb,
  mail: Mail,
  map: MapIcon,
  medal: Medal,
  megaphone: Megaphone,
  "message-square": MessageSquare,
  mic: Mic,
  music: Music,
  package: Package,
  "pen-tool": PenTool,
  percent: Percent,
  phone: Phone,
  plus: Plus,
  podcast: Podcast,
  radio: Radio,
  rocket: Rocket,
  school: School,
  send: Send,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  sliders: Sliders,
  sparkles: Sparkles,
  sprout: Sprout,
  star: Star,
  tag: Tag,
  target: Target,
  ticket: Ticket,
  timer: Timer,
  "trending-up": TrendingUp,
  trophy: Trophy,
  "user-plus": UserPlus,
  users: Users,
  video: Video,
  wallet: Wallet,
  wand: Wand,
  zap: Zap,
};

interface DynamicIconProps {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  className?: string;
}

export const DynamicIcon = memo(function DynamicIcon({
  name,
  size = 20,
  color,
  strokeWidth = 1.75,
  className,
}: DynamicIconProps) {
  const Cmp = REGISTRY[name] ?? Sparkles;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      className={className}
      aria-hidden="true"
    />
  );
});
